(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["id-main-article"]) return;
  try {
    
$(function(){
  gsap.registerPlugin(ScrollTrigger);
  
  let mm = gsap.matchMedia();
  
  mm.add("(min-width: 769px)", () => {
    let header = document.querySelector(".id-article__header-inner");
    let body = document.querySelector(".id-article__body");
  
    ScrollTrigger.create({
      trigger: body,
      start: "top-=30 top",
      end: () => {
        return "+=" + (body.offsetHeight - header.offsetHeight);
      },
      pin: header,
      pinSpacing: false,
      scrub: false
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["id-main-blog"]) return;
  try {
    
$(function() {
  const currentPath = decodeURIComponent(window.location.pathname);
  $('.id-info-tag__item a').each(function() {
    const href = $(this).attr('href');

    if (href === currentPath) {
      $(this).addClass('active');
    }
  });
  
  $('.id-info-archive-list__item').click(function(){
     var link = $(this).find('.id-info-archive-list__title a').attr('href');
     if (link) {
         window.location.href = link;
       }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["id-main-password-page-content"]) return;
  try {
    
    var queryString = window.location.search;
    if(queryString == '?ides'){
        $('.header__btn-password').show();
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["id-main-product"]) return;
  try {
    
$(function(){
  gsap.registerPlugin(ScrollTrigger);
  //item detail fixed btn
  ScrollTrigger.matchMedia({
    // 768px以下の時だけ処理
    "(max-width: 768px)": function () {
      $('.id-fixed-add-to-cart').each(function() {
        const $clone = $(this).clone().addClass('id-fixed');
        $(this).after($clone);
      });
  
      gsap.to(".id-fixed-add-to-cart.id-fixed", {
      y: '0',
      duration: 0.3,
      scrollTrigger: {
        trigger: ".id-fixed-add-to-cart:not(.id-fixed)",
        start: "bottom top",
        endTrigger: ".id-p__right",
        end: "bottom bottom-=200",
        toggleActions: "play reverse play reverse",
        markers: false
      }
      });
      
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["id-main-register"]) return;
  try {
    
  $(function () {
    //お子さまが使用の場合
    $('#user').on('change', function () {
      const selected = $(this).val();
  
      if (selected === '子どもが使用') {
        $('.id-register-child').fadeIn();
        $('#childName, #childBirthday').attr('required', 'required');
      } else {
        $('.id-register-child').fadeOut();
        $('#childName, #childBirthday').removeAttr('required');
      }
    });
    
    //送信時に空のnoteを削除
    $('form#create_customer').on('submit', function() {
      $(this)
        .find('[name^="customer[note]"]')
        .each(function() {
          if (!$(this).val().trim()) {
            $(this).remove();
          }
        });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
